module.exports = __webpack_public_path__ + "img/caret-down.34b30039.svg";